import { createContext } from 'react';
import { TContext } from './FloatingMenu';

export const FloatingMenuContext = createContext<TContext | null>(null);